export default __webpack_public_path__ + "static/media/room.69f22c42.png";